import { createColumnHelper } from '@tanstack/react-table'

import { format } from 'date-fns'
import { Transaction } from '../../../../../app/entities/Transaction'
import { formatMoneyValue } from '../../../../../app/utils/formatMoneyValue'

import { BasicAvatar } from '../../../../components/BasicAvatar'
import Status from '../../../../components/Status'
import { formatName } from '@/app/utils/formatName'
import { getImageByType } from '@/app/utils/getImageByType'

const columnHelper = createColumnHelper<Transaction>()

const columns = [
  columnHelper.accessor('contract', {
    id: 'contract',
    header: () => (
      <div className="flex flex-col items-start pl-2 xl:items-center xl:pl-0">
        <div>Contrato</div>
        <div className="block text-black04 xl:hidden">Vendedor</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex flex-col items-start pl-4">
        <div>
          {String(row.original.contract).length !== 24
            ? row.original.contract
            : '-'}
        </div>

        <div className="block text-black04 2xl:hidden">
          {formatName(row.original.seller.name)}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('type', {
    id: 'type',
    header: () => <div className="hidden pl-2 text-left xs:block">Produto</div>,
    cell: ({ row }) => {
      const type = row.original.type
      const imageSrc = getImageByType(type)

      return (
        <div className="hidden items-center justify-start pl-6 text-left xs:flex">
          <img
            src={imageSrc}
            className="mb-1 h-8 w-8 rounded-lg object-contain"
            alt={type}
          />
        </div>
      )
    },
  }),
  columnHelper.accessor('seller', {
    id: 'vendedor',
    header: () => <div className="hidden text-left 2xl:block">Vendedor</div>,
    cell: ({ row }) => (
      <div className="hidden 2xl:block">
        <div className="flex items-center gap-2">
          <BasicAvatar
            name={row.original.seller.name}
            profileImageUrl={row.original.seller.profileImageUrl}
          />
          <p>{formatName(row.original.seller.name)}</p>
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('createdAt', {
    id: 'data',
    header: () => <div className="hidden text-center xl:block">Data</div>,
    cell: ({ row }) => (
      <div className="hidden text-center xl:block ">
        {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
      </div>
    ),
  }),
  columnHelper.accessor('value', {
    id: 'value',
    header: () => (
      <div className="flex flex-col items-end pr-2 xl:items-center xl:pr-0">
        <div>Valor</div>
        <div className="block text-black04 xl:hidden">Data</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex flex-col items-end pr-4 xl:items-center xl:pr-0">
        <div className="text-left xl:text-center">
          {formatMoneyValue(row.original.value)}
        </div>
        <div className="block text-black04 2xl:hidden">
          {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
        </div>
      </div>
    ),
  }),

  columnHelper.accessor('actualStatus', {
    id: 'actualStatus',
    header: () => <div className="hidden pr-2 text-end xl:block">Status</div>,
    cell: ({ row }) => (
      <div className="hidden xl:block">
        <div className="flex items-center justify-end pr-4">
          <Status status={row.getValue('actualStatus')} />
        </div>
      </div>
    ),
  }),
]

export const TableColumnsTeamTransactions = () => {
  return {
    columns,
  }
}
